import { Modal, ModalBody, ModalContent } from '@nextui-org/react-latest'
import { useState } from 'react'
import dynamic from 'next/dynamic'
// import LoadingAnimation from '@public/static/images/animations/loading.conversation.json'
import StepOne from './steps/StepOne'
import StepTwo from './steps/StepTwo'
import StepThree from './steps/StepThree'
import StepFour from './steps/StepFour'
import StepFive from './steps/StepFive'
import useWindowDimensions from '@hooks/useWindowDimensions'
import useLoadAnimations from '@hooks/useLoadAnimations'

// Dynamic import of Lottie with SSR disabled
const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
  loading: () => <div style={{ minHeight: '100px', width: '100%' }} />,
})

type Props = {
  isOpen: boolean
  onOpenChange: () => void
}

const ConnectWithUsModal = ({ isOpen, onOpenChange }: Props) => {
  const [currentStep, setCurrentStep] = useState<
    'stepone' | 'steptwo' | 'stepthree' | 'stepfour' | 'stepfive'
  >('stepone')
  const [amountOfCourses, setAmountOfCourses] = useState<
    '0to1' | '1to5' | '6plus'
  >('0to1')
  const [studentAudience, setStudentAudience] = useState<
    'lessThen5000' | 'moreThen5000' | 'moreThen20000'
  >('lessThen5000')
  const [inquiryType, setInquiryType] = useState<
    | 'introductionToEdugramFeatures'
    | 'accountSetupAndVerification'
    | 'contentCreationAndPublishingGuidelines'
    | 'earningOpportunitiesAndRevenueModels'
    | 'technicalSupportAndTroubleshooting'
    | 'feedbackAndImprovementSuggestions'
    | 'generalInquiry'
    | 'other'
    | ''
  >('')
  const [inquiryDetails, setInquiryDetails] = useState<string>('')
  const { animations } = useLoadAnimations({
    animations: [
      {
        path: '/static/images/animations/loading.conversation.json',
        key: 'LoadingAnimation',
      },
    ],
  })
  const { width } = useWindowDimensions()

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      scrollBehavior={(width || 0) <= 640 ? 'inside' : 'outside'}
      classNames={{
        closeButton:
          'mt-2 mr-2 bg-white rounded-full sm:shadow-none shadow z-10',
      }}
      placement={(width || 0) <= 640 ? 'bottom' : 'center'}
      shouldBlockScroll={false}
    >
      <ModalContent
        className={`${
          (width || 0) <= 640
            ? 'w-full m-0 max-w-full !mx-0 !my-0 rounded-b-none'
            : ''
        }`}
      >
        {(onClose) => (
          <>
            {/* <ModalHeader> */}

            {/* </ModalHeader> */}
            <ModalBody className="overflow-hidden">
              {currentStep !== 'stepfive' && (
                <div className="w-28 h-28">
                  <Lottie
                    options={{
                      loop: true, // Set to true if you want the animation to loop
                      autoplay: true,

                      rendererSettings: {
                        // preserveAspectRatio: 'xMidYMid slice',
                      },
                      animationData: animations.LoadingAnimation,
                    }}
                  />
                </div>
              )}
              {currentStep === 'stepone' ? (
                <StepOne
                  setCurrentStep={setCurrentStep}
                  setAmountOfCourses={setAmountOfCourses}
                  amountOfCourses={amountOfCourses}
                />
              ) : currentStep === 'steptwo' ? (
                <StepTwo
                  setStudentAudience={setStudentAudience}
                  setCurrentStep={setCurrentStep}
                  studentAudience={studentAudience}
                />
              ) : currentStep === 'stepthree' ? (
                <StepThree
                  setCurrentStep={setCurrentStep}
                  setInquiryType={setInquiryType}
                  inquiryType={inquiryType}
                  setInquiryDetails={setInquiryDetails}
                  inquiryDetails={inquiryDetails}
                />
              ) : currentStep === 'stepfour' ? (
                <StepFour
                  setCurrentStep={setCurrentStep}
                  inquiryDetails={inquiryDetails}
                  inquiryType={inquiryType}
                  studentAudience={studentAudience}
                  amountOfCourses={amountOfCourses}
                />
              ) : currentStep === 'stepfive' ? (
                <StepFive onClose={onClose} setCurrentStep={setCurrentStep} />
              ) : null}
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ConnectWithUsModal
